import React from 'react'

import { useCopyToClipboard, useToast } from '@/hooks'

interface CopyToClipboardProps extends React.ComponentProps<'div'> {
  text: string
  children: React.ReactNode
  copiedSuccessMessage?: string
  copiedFailMessage?: string
  stopPropagation?: boolean
}

export function CopyToClipboard({
  text,
  children,
  copiedSuccessMessage = 'Copied',
  copiedFailMessage = 'Copy Failed',
  stopPropagation = false,
  ...rest
}: CopyToClipboardProps) {
  const [_, copy] = useCopyToClipboard()
  const { toast } = useToast()

  const handleCopy = async (e: React.MouseEvent<HTMLDivElement>) => {
    if (stopPropagation) e.stopPropagation()
    const success = await copy(text)
    if (success) {
      toast({
        title: 'Success',
        description: copiedSuccessMessage,
      })
    } else {
      toast({
        title: 'Failed',
        description: copiedFailMessage,
      })
    }
  }

  return (
    <div className='cursor-pointer' onClick={handleCopy} {...rest}>
      {children}
    </div>
  )
}
